<div class="w-100 d-flex justify-content-center" style="font-size: 45px">
  <button *ngIf="!visibleSignature()" class="border-0 bg-transparent" (click)="visibleSignature.set(true);" >
      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
  </button>
  
</div>

<p-dialog header="Firma" [visible]="visibleSignature()" (onShow)="ngAfterViewInit()">
  <div class="">
    <canvas #signaturePad [width]="'100%'" [height]="canvasHeight"></canvas>
  </div>

  <ng-template #footer>
    <div class="w-100 d-flex flex-row justify-content-center  gap-4">
      <button pButton severity="warn" (click)="clearPad()">Limpiar</button>
      <button pButton severity="success" (click)="saveSign()">Guardar</button>
      <button pButton severity="secondary" (click)="visibleSignature.set(false)">Cerrar</button>
    </div>
  </ng-template>
</p-dialog>
